import { RefObject } from 'preact';
import { useCallback, useRef, useState } from 'preact/hooks';
import { detectTruncation } from '#utils/PRIVATE_truncationUtils';

type Props = {
  isDisabled?: boolean;
  rootRef: RefObject<HTMLLabelElement>;
};

/**
 * Hook that detects truncated text when you hover the mouse over a label.
 */
const useDetectLabelTruncation = ({ isDisabled = false, rootRef }: Props) => {
  const [isTextTruncated, setIsTextTruncated] = useState<boolean>(false);
  const mouseOverTimerRef = useRef<ReturnType<typeof setTimeout> | undefined>();

  const handleMouseOver = useCallback(() => {
    clearTimeout(mouseOverTimerRef.current);
    // Determine if the label is truncated after the user hovers over it.
    mouseOverTimerRef.current = setTimeout(() => {
      const isTruncated = detectTruncation(rootRef as RefObject<HTMLElement>);
      setIsTextTruncated(isTruncated);
    }, 1000);
  }, [rootRef]);

  const handleMouseOut = useCallback(() => {
    clearTimeout(mouseOverTimerRef.current);
    mouseOverTimerRef.current = undefined;
    setIsTextTruncated(false);
  }, []);

  const detectTruncationProps = !isDisabled
    ? {
        onMouseOver: handleMouseOver,
        onMouseOut: handleMouseOut
      }
    : {};

  return { detectTruncationProps, isTextTruncated };
};

export { useDetectLabelTruncation };
